import * as I18n from 'i18n-js';

import * as enTranslations from '../translations/en';

// Global config
I18n.fallbacks = true;
I18n.locales.eo = []; // Translator's Locale

I18n.translations.en = enTranslations;



// WEBPACK FOOTER //
// ./javascripts/components/translations.js